module.exports = __webpack_public_path__ + "static/media/ng-instagram-comments.07b6aa97.png";